// extracted by mini-css-extract-plugin
export default {"chart_wrap":"RevenueGraph_chart_wrap__PxRRm","chart_header":"RevenueGraph_chart_header__Y4c+d","label":"RevenueGraph_label__DNTSD","chart_footer":"RevenueGraph_chart_footer__IaytU"};